import { TooltipDirective } from '../../tooltip/tooltip.directive';
import { BOTONES } from '../../../componentes/botones';
import { Component, ViewEncapsulation, inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NivelObjetivo } from 'modelos/src';
import {
  IJerarquiaLuminaria,
  LuminariasHttpService,
} from '../../servicios/http/luminarias.service';
import { ButtonComponent } from '../../button/button.component';
import { ContentCardComponent } from '../../../componentes/content-card/content-card.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { JerarquiaPerfilesComponent } from '../jerarquia-perfiles/jerarquia-perfiles.component';
import { CardHeaderComponent } from '../../../componentes/card-header/card-header.component';
import { FormularioDialogService } from '../../servicios/formulario-dialog.service';

// Confirmación de envío de un comando MANUAL de configuración a un objetivo
// grupal: muestra a cuántas luminarias del tipo alcanza y avisa que los valores
// enviados pasan a ser la configuración deseada. Un botón "ojo" abre el detalle
// completo (jerarquía de perfiles) de las luminarias alcanzadas.
// El diálogo se abre de inmediato y consulta la jerarquía con un spinner;
// si la consulta falla o no hay luminarias del tipo, cierra con `true`
// (no bloquea el envío).
export interface DataConfirmarEnvioManual {
  comandoNombre: string;
  tipo: string; // tipoDispositivo, ej 'Luminaria GPE'
  nivel: NivelObjetivo;
  id: string;
  nombre?: string;
}

@Component({
  selector: 'app-confirmar-envio-manual',
  standalone: true,
  imports: [TooltipDirective, BOTONES, 
    MatDialogModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    
    ButtonComponent,
    CardHeaderComponent,
    ContentCardComponent,
    InfoBannerComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './confirmar-envio-manual.component.html',
  styleUrls: ['./confirmar-envio-manual.component.scss'],
})
export class ConfirmarEnvioManualComponent {
  dialogRef =
    inject<MatDialogRef<ConfirmarEnvioManualComponent, boolean>>(MatDialogRef);
  data = inject<DataConfirmarEnvioManual>(MAT_DIALOG_DATA);
  private luminariasService = inject(LuminariasHttpService);
  private formularios = inject(FormularioDialogService);

  cargando = signal(true);
  resumen = signal<{
    total: number;
    elegibles: number;
    ignoradas: number;
  } | null>(null);
  ignoradas = signal<IJerarquiaLuminaria[]>([]);

  get tipoLabel(): string {
    return this.data.tipo.replace('Luminaria ', '');
  }

  constructor() {
    this.cargar();
  }

  private async cargar(): Promise<void> {
    try {
      const j = await this.luminariasService.jerarquiaObjetivo(
        this.data.nivel,
        this.data.id,
      );
      const r = j.resumenPorTipo[this.data.tipo];
      if (!r) {
        // Sin luminarias del tipo: no bloqueamos el envío.
        this.dialogRef.close(true);
        return;
      }
      this.resumen.set(r);
      this.ignoradas.set(
        j.luminarias.filter((l) => l.tipo === this.data.tipo && !l.elegible),
      );
    } catch (e) {
      console.error(e);
      // Fallo de la consulta informativa: no bloqueamos el envío.
      this.dialogRef.close(true);
      return;
    } finally {
      this.cargando.set(false);
    }
  }

  // Abre el detalle completo de las luminarias alcanzadas (jerarquía de
  // perfiles del objetivo), reutilizando el componente de "ver jerarquía".
  verDetalle(): void {
    this.formularios.abrir(JerarquiaPerfilesComponent, {
      tamano: 'mediano',
      cerrarAfuera: true,
      data: {
        nivel: this.data.nivel,
        id: this.data.id,
        nombre: this.data.nombre,
      },
    });
  }
}
